
<template>
        <l-map ref="map"
            style="height: 600px;" :zoom="zoom"  :center="center" :bounds="mbounds"
            >

          <!--  <l-tile-layer :url="cadastre"  :attribution="attribution"></l-tile-layer>-->
            <l-tile-layer :url="url" :attribution="attribution" :subdomains="subdomains"></l-tile-layer>

            <l-marker :lat-lng="mposition" ref="marker">
                <l-popup>
                    <b>Date</b> : {{last_update}}
                </l-popup>
            </l-marker>

            <l-circle :lat-lng="mposition" :radius="mprecision" :color="circle_color"/>

        </l-map>
</template>

<script>
    import {latLng} from 'leaflet';
    import { LMap, LTileLayer, LMarker, LCircle, LPopup } from 'vue2-leaflet';

    import { mapGetters } from 'vuex';

    export default {
        name: 'MyAwesomeMap',
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LCircle
        },
        props: {
            location_info: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        id: 1,
                        Date_on_last_pos : '2021-08-30', 
                        geolocation_precision: 5000,
                        latitude: 0,
                        longitude: 0
                    }
                }
            }
        },
        data () {
            return {
                //url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',   //google map street
               // url: 'http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',   //google map hybrid
              //  url: 'http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',   //google map satelitte
              //  url: 'http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',   //google map terrain
              //  subdomains:['mt0', 'mt1', 'mt2', 'mt3'],
             //   url :'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
               // url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',   //esri sattelite
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                subdomains: null,//pour openstreet map
                attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                cadastre : 'https://openmaptiles.geo.data.gouv.fr/data/cadastre/{z}/{x}/{y}.pbf',
                zoom: Math.min(14,parseInt(Math.log2(591657550.5 / (this.location_info.geolocation_precision * 180))) + 2),
                mposition: latLng(this.location_info.latitude, this.location_info.longitude),
                center: latLng(this.location_info.latitude, this.location_info.longitude),
                mbounds: null,
                mprecision : this.location_info.geolocation_precision,
                circle_color : 'green',
                last_update : this.location_info.Date_on_last_pos
            };
        },
        computed: {
			...mapGetters({
                structure : 'structure/structure'
			})
		},
        mounted() {
            this.$nextTick(() => {
                this.$refs.map.center = this.center;
                setTimeout(function() {
                    this.$refs.marker.mapObject.openPopup();
                }.bind(this), 500);
            }); 
            setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
            }, 250);
        },
        methods: {
        },
    };

</script>